import makeService from './api';

export default makeService('sites');
